import React, { useEffect} from "react";
import "./App.css";
import {
  Admin,
  CustomRoutes,
  defaultTheme,
  Resource,
  useGetIdentity,
  useStore,
} from "react-admin";
import {
  Route,
  useNavigate,
  } from "react-router-dom";
import { dataProvidersAts } from "./dataproviders/DataProvidersAts";
import "./assets/styles/style.css";
import ApplicantDetailEdit from "./componets/Ats/ApplicantDetailEdit";
import { Provider } from "react-redux";
import store from "./Store/store";
import Login from "./Container/Login/Login";
import DocumentView from "./componets/Ats/DocumentView";
import { UserRoleProvider } from "./ContextApi/UserRoleContext";
import TempPassWordResetUserSetup from "./Container/ATS/TempPassWordResetUserSetup";
import TermsConditionLandLoardSetup from "./Container/ATS/TermsConditionLandLoardSetup";
import MyLayoutLandLoard from "./componets/MyLayoutLandLoard";
import { GetListLandLoardList } from "./componets/Ats/LandLoard/GetListLandLoardList";
import ViewAdverseLetter from "./componets/Ats/LandLoard/ViewAdverseLetter";
import authProviderLandLoard from "./authProviders/authProvidersLandLoard";

const theme = {
  ...defaultTheme,
  sidebar: {
    width: 240, // The default value is 240
    closedWidth: 66, // The default value is 55
  },
  appbar: {
    // root: {
    //   backgroundColor: 'red'
    // }
  },
  typography: {
    fontFamily: ["'Open Sans'", " sans-serif"].join(","),
    fontSize: 12,
    fontWeight: 400,
    LineHeight: 16,
  },
  palette: {
    primary: {
      // light: will be calculated from palette.primary.main,
      main: "#2cc0e4",
      contrastText: "#fff",
      // dark: will be calculated from palette.primary.main,
      // contrastText: will be calculated to contrast with palette.primary.main
    },
    secondary: {
      light: "#0066ff",
      main: "#4BD5E7",
      // dark: will be calculated from palette.secondary.main,
      contrastText: "#fff",
    },
    error: {
      main: "#ff4848",
      contrastText: "#fff",
    },
    warning: {
      main: "#f9bb04",
      contrastText: "#fff",
    },
    success: {
      main: "#46a96f",
      contrastText: "#fff",
    },
    custom: "#fff",
  },
  components: {
    ...defaultTheme.components,
    MuiTextField: {
      defaultProps: {
        variant: "outlined" as const,
      },
    },
    MuiFormControl: {
      defaultProps: {
        variant: "outlined" as const,
      },
    },
  },
};


export const SubscriberSwitchValidation = (props) => {
  const [switchSubscriberObj, setSwitchSubscriberObj] = useStore("switchSubscriberName");
  const { data } = useGetIdentity();
  const { Component } = props;
  const navigate = useNavigate();
  useEffect(() => {
    if (props.isAdmin && localStorage.getItem("RaStore.switchSubscriber") === "true") {
      navigate(`/ats/Subscriber/Inbox/${switchSubscriberObj?.value}`, { replace: true })
    }
    else if (!props.isAdmin && localStorage.getItem("RaStore.switchSubscriber") === "false") {
      setSwitchSubscriberObj({});
      navigate("/ats", { replace: true });
    }
  }, [data, props])
  return <Component type={props?.type} />
}

const AtsAppLandloard = () => {
  return (
    <Provider store={store}>
      <Admin
        theme={theme}
        layout={MyLayoutLandLoard}
        authProvider={authProviderLandLoard}
        requireAuth
        loginPage={Login}
        basename="/landloard"
        dataProvider={dataProvidersAts}
      >
        <Resource name="landLoardInbox" list={GetListLandLoardList} />
        <CustomRoutes noLayout>
          <Route path="/TermsAndConditionForUserLandLoard" >
            <Route path="/TermsAndConditionForUserLandLoard" element={<TermsConditionLandLoardSetup />} />
          </Route>
          <Route path="/TempForgotPassword" element={<TempPassWordResetUserSetup />} />
        </CustomRoutes>
        <CustomRoutes>
          <Route
            path="/landLoardInbox/View/:id/edit/:applicationId/:appType"
            element={<UserRoleProvider defaultRole=""><ApplicantDetailEdit /></UserRoleProvider>}
          />
          <Route
            path="/landLoardInbox/adverseletter"
            element={<ViewAdverseLetter />}
          />
          <Route path="/docview" element={<DocumentView />} />
         
        </CustomRoutes>
      </Admin>
    </Provider>
  );
};

export default AtsAppLandloard;
